// ** Custom Hooks
import { useTeamAgentsData } from "../../hooks/use-team-agents-data"

// ** Custom Components
import Box from "../../components/Box"
import Container from "../../components/Container"
import StaffCard from "../../components/StaffCard"
import { classNames } from "../../utils/helpers"

import SectionTeamLeads from "./TeamAgentsSectionTeamLeads"
import SectionTeamAgents from "./TeamAgentsSectionMortgageAgents"
import SectionUnderwriters from "./TeamAgentsSectionUnderwriters"

const TeamAgentsSectionStaffCards = () => {
  const teamsData = useTeamAgentsData()
  const director = teamsData.filter((staff: any) => {
    if (staff.tags.includes("director")) {
      return staff
    }
  })

  return (
    <Box className="flex flex-col gap-12 lg:gap-16">
      <Container fullWidthOnMobile={false} constrainedToBreakPoint>
          <Box
            className={classNames(
              "flex justify-center",
              director.length > 1 && "flex-wrap gap-x-6"
            )}
          >
            {director.map((staff: any) => (
              <StaffCard staff={staff} key={staff.id} />
            ))}
          </Box>
        </Container>

        <SectionTeamLeads />
        <SectionTeamAgents />
        <SectionUnderwriters />
    </Box>
  )
}

export default TeamAgentsSectionStaffCards